import React, { useEffect, useState } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { CssBaseline, Box, Button, Typography } from '@mui/material';
import { HelmetProvider } from 'react-helmet-async';
import { AuthProvider } from './contexts/AuthContext';
import { HomePage } from './pages/HomePage';

// Configuration du thème Material UI
const theme = createTheme({
  palette: {
    primary: {
      main: '#E7B649',
    },
    secondary: {
      main: '#D23831',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
});

function App() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showiOSInstall, setShowiOSInstall] = useState(false);

  useEffect(() => {
    // Gestion Android/Chrome
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);

    // Détection iOS
    const isIOS = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
    const isInStandaloneMode = ('standalone' in window.navigator) && window.navigator.standalone;
    if (isIOS && !isInStandaloneMode) {
      setShowiOSInstall(true);
    }

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(() => setDeferredPrompt(null));
    }
  };

  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {/* Bouton d'installation PWA pour Android/Chrome */}
        {deferredPrompt && (
          <Box sx={{ position: 'fixed', bottom: 24, right: 24, zIndex: 2000 }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleInstallClick}
            >
              Installer l’application
            </Button>
          </Box>
        )}
        {/* Message d'aide iOS */}
        {showiOSInstall && (
          <Box sx={{
            position: 'fixed', bottom: 24, left: 24, zIndex: 2000, bgcolor: 'background.paper',
            p: 2, borderRadius: 2, boxShadow: 3, maxWidth: 320
          }}>
            <Typography variant="body2">
              Pour installer cette application sur votre iPhone ou iPad, ouvrez le menu de partage de Safari
              <span role="img" aria-label="partager"> ⬆️ </span>
              puis choisissez <b>« Sur l’écran d’accueil »</b>.
            </Typography>
          </Box>
        )}
        <AuthProvider>
          <HomePage />
        </AuthProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
